module.exports = __webpack_public_path__ + "img/img-equipment.35efd284.png";